import React, { PropsWithChildren, ReactElement } from 'react';
import { CellTypeEnum, DataRecordTableCell } from 'src/libraries/data-record-table';
import { FilterGeneratorDate } from './filter-generator-date';
import { FilterGeneratorText } from './filter-generator-text';
import { FilterGeneratorNumber } from './filter-generator-number';

export interface FilterGeneratorProps<Data> {
  cellData: DataRecordTableCell<Data>;
}

const FilterGenerator = <Data,>(props: PropsWithChildren<FilterGeneratorProps<Data>>): ReactElement | null => {
  const { cellData } = props;

  const renderFilterTypeComponent = () => {
    switch (cellData.type) {
      case CellTypeEnum.text:
        return <FilterGeneratorText cellData={cellData} />;
      case CellTypeEnum.number:
        return <FilterGeneratorNumber cellData={cellData} />;
      case CellTypeEnum.currency:
        return <FilterGeneratorNumber cellData={cellData} isCurrency />;
      case CellTypeEnum.percentage:
        return <FilterGeneratorNumber cellData={cellData} isPercentage />;
      case CellTypeEnum.date:
        return <FilterGeneratorDate cellData={cellData} />;
      default:
        return <FilterGeneratorText cellData={cellData} />;
    }
  };

  return renderFilterTypeComponent();
};

export default FilterGenerator;
